// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/view/tyre/workdoc/assetwork.css
// module id = 2046
// module chunks = 0